/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsBlogPostSingle = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsBlogPostSingle = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');

      if (this.mobile_slider && window.innerWidth < 799) {
        this.createSlider($sliderEl);
      }
    },
    createSlider: function ($sliderEl) {

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'center',
        adaptiveHeight: true,
        // wrapAround: true,
        groupCells: true,
        pageDots: false,
        contain: true,
        prevNextButtons: true,
        initialIndex: 0,
        arrowShape: arrowShape
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;